<template>
  <div class="workflow-history">
    <div class="top-select" v-if="!processDetailVisible">
      <div class="select-title">状态：</div>
      <el-select
        v-model="doStatus"
        placeholder="请选择"
        clearable
        style="width:120px"
        @change="changeData"
      >
        <el-option label="进行中" value="进行中"></el-option>
        <el-option label="完成" value="完成"></el-option>
        <el-option label="执行错误" value="执行错误"></el-option>
      </el-select>
      <div class="select-title">流程数据：</div>
      <el-input
        v-model="title"
        placeholder="请输入内容"
        clearable
        size="small"
        style="width:210px"
        @change="changeData"
        prefix-icon="el-icon-search"
      ></el-input>
      <div class="select-title">执行时间：</div>
      <el-date-picker
        v-model="date"
        type="datetimerange"
        range-separator="至"
        value-format="yyyy-MM-dd HH:mm:ss"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        style="width:340px"
        @change="changeData"
      ></el-date-picker>
    </div>
    <el-table
      v-if="!this.processDetailVisible"
      v-loading="loading"
      :data="historyList"
      class="history-list"
      @row-click="rowClick"
      v-ps="'.el-table__body-wrapper'"
      height=" calc(100% - 35px)"
    >
      <el-table-column prop="status" label="状态" width="130">
        <template slot-scope="scope">
          <i v-if="scope.row.status == '进行中'" class="el-icon-time icon-status"></i>
          <i v-if="scope.row.status == '完成'" class="el-icon-success icon-status"></i>
          <i v-if="scope.row.status == '执行错误'" class="el-icon-error icon-status"></i>
          {{ scope.row.status }}
        </template>
      </el-table-column>
      <el-table-column prop="triggerTitle" label="触发流程数据" width="130"></el-table-column>
      <el-table-column prop="errorMsg" label="执行结果" width="280"></el-table-column>
      <el-table-column prop="startTime" label="开始时间" min-width="170"></el-table-column>
      <el-table-column prop="endTime" label="结束时间" min-width="170"></el-table-column>
    </el-table>
    <ProcessDetail v-else :processDetail="processDetail" @hide="hideProcessDetail"></ProcessDetail>
  </div>
</template>

<script>
import { getProcessHistory, getProcessHistoryList } from "@/api/workflow/processHistory"
import ProcessDetail from "./processDetail"

export default {
  name: "workFlowHistory",
  components: {
    ProcessDetail
  },
  props: {
    workflowId: String
  },
  data() {
    return {
      loading: false,
      processDetailVisible: false,
      processDetail: null,
      title: "",
      doStatus: "",
      historyList: [],
      page: 1,
      size: 20,
      date: [],
      loadFinished: false
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    this.rollLoad()
  },
  methods: {
    rollLoad() {
      let tableBody = this.$el.querySelector(".el-table__body-wrapper")
      tableBody.addEventListener("ps-y-reach-end", () => this.loadData())
    },
    loadData() {
      if (this.loading || this.loadFinished) return
      this.loading = true
      // 请求流程历史每条数据的具体信息
      getProcessHistoryList(
        this.workflowId,
        this.date?.[0] || null,
        this.date?.[1] || null,
        this.page,
        this.size,
        this.doStatus,
        this.title
      )
        .then(historyList => {
          this.historyList = this.historyList.concat(historyList)
          if (historyList.length < this.size) {
            this.loadFinished = true
          }
          this.page++
        })
        .finally(() => (this.loading = false))
    },
    // 表格行点击事件
    rowClick(row) {
      this.processDetail = null
      getProcessHistory(row.id).then(processDetail => {
        this.processDetail = processDetail
        this.processDetailVisible = true
      })
    },
    // 隐藏工作流运行详情
    hideProcessDetail() {
      this.processDetailVisible = false
      this.$nextTick(() => {
        this.rollLoad()
      })
    },
    changeData(val) {
      this.historyList = []
      this.page = 1
      this.loadFinished = false
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.workflow-history {
  height: calc(100vh - 60px - 55px);
  max-width: 960px;
  margin: 40px auto 20px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
  padding: 14px 24px 24px 24px;
  box-sizing: border-box;
  .top-select {
    display: flex;
    align-items: center;
    margin: 2px auto 10px;
    .select-title {
      font-size: 14px;
      margin-left: 12px;
    }
  }
  .history-list {
    ::v-deep .el-table__empty-block {
      min-height: 500px;
    }
    ::v-deep .el-table__body-wrapper {
      cursor: pointer;
    }
    .icon-status {
      font-size: 28px;
      vertical-align: middle;
      margin-right: 3px;
    }
    .el-icon-time {
      color: #2195f3;
    }
    .el-icon-success {
      color: #01ca83;
    }
    .el-icon-error {
      color: #ca3820;
    }
  }
}
</style>
